export default __webpack_public_path__ + "static/media/swiftPM.b663b57b.png";